/** Obrazovky administrace (docs/UI.md). */
export const SCREENS = [
    'overview',
    'races',
    'customers',
    'trips',
    'communication',
    'compose',
    'transactional',
    'reviews',
    'exceptions',
    'revenue',
    'data_quality',
    'jobs',
    'settings',
    'simulator',
    'care',
    'web_behavior',
    'deliverability',
];
const row = (admin, customer_care, mailing, obchod, marketing) => ({ admin, customer_care, mailing, obchod, marketing });
/** Tabulka práv (docs/UI.md, návrh kap. 4). Sloupce: admin, customer_care, mailing, obchod, marketing. */
export const ACCESS = {
    overview: row('read', 'read', 'read', 'read', 'read'),
    races: row('write', 'read', 'read', 'write', 'read'),
    customers: row('write', 'write', 'read', 'read', 'none'),
    trips: row('write', 'read', 'read', 'read', 'none'),
    communication: row('write', 'read', 'write', 'read', 'read'),
    /** Odeslat rozesílku: průvodce (šablona, závod, komu, kontrola); práva jako Komunikace. */
    compose: row('write', 'read', 'write', 'read', 'read'),
    transactional: row('write', 'read', 'write', 'write', 'none'),
    reviews: row('write', 'partial', 'read', 'read', 'read'),
    exceptions: row('write', 'write', 'write', 'write', 'none'),
    revenue: row('read', 'none', 'read', 'read', 'read'),
    data_quality: row('read', 'none', 'read', 'read', 'read'),
    jobs: row('write', 'none', 'write', 'none', 'none'),
    settings: row('write', 'none', 'partial', 'none', 'none'),
    simulator: row('write', 'none', 'write', 'none', 'none'),
    care: row('write', 'write', 'none', 'none', 'none'),
    /** Chování na webu po e-mailu (funnel, zprávy, zdraví webů); zápis nemá nikdo, weby spravuje `manage_users`. */
    web_behavior: row('read', 'none', 'read', 'read', 'read'),
    /** Doručitelnost (D-322): statistiky, ověření domén, reputace; mailing mění prahy, marketing čte. */
    deliverability: row('write', 'none', 'write', 'none', 'read'),
};
/** Jednotliva prava, ktera nejdou vyjadrit pres obrazovku. */
export const CAPABILITIES = [
    /** Prepinac "smi odejit" u kodu zpravy. */
    'toggle_send_switch',
    /** Schvalit / pozdrzet / preskocit davku hodnoceni, vybrat a importovat prijemce. */
    'decide_review_batch',
    /** Zmenit rezim odesilani. */
    'change_send_mode',
    /** Vymazat kontakt (GDPR). */
    'delete_contact',
    /** Spravovat uzivatele. */
    'manage_users',
    /** Mapovat sablony. */
    'map_templates',
    /** Ovladat simulator. */
    'use_simulator',
    /** Navrhnout zmenu katalogu pravidel (SPEC-2 M12). */
    'edit_catalogue',
    /** Publikovat katalog pravidel — jen admin (AC-72). */
    'publish_catalogue',
    /** Opakovat chybne prichozi udalosti (Kvalita dat). */
    'retry_events',
    /** Případy, označení zákazníků, návrhy a import případů (D-107 až D-109). */
    'manage_care',
    /** Volný text případů a označení (poznámky, řešení) — osobní údaje. */
    'view_care_notes',
    /** Test odesílání a test toku v prostředí s odesíláním omezeným na TEST_ALLOWLIST (D-120). */
    'run_send_tests',
    /** Přepnout aktivní prostředí hubu (vývoj / zkouška / produkce, D-132). */
    'switch_environment',
    /** Zapnout a vypnout vrstvy nasazení (vlny, D-250); strop dává nasazení. */
    'manage_layers',
    /** Schválit, naplánovat, potvrdit krok a přerušit rozesílku (vlna 1); MCP toto právo nepoužívá. */
    'send_broadcast',
];
export const CAPABILITY_DEPARTMENTS = {
    toggle_send_switch: ['admin', 'mailing'],
    decide_review_batch: ['admin', 'customer_care'],
    change_send_mode: ['admin'],
    delete_contact: ['admin', 'customer_care'],
    manage_users: ['admin'],
    map_templates: ['admin', 'mailing'],
    use_simulator: ['admin', 'mailing'],
    edit_catalogue: ['admin', 'mailing'],
    publish_catalogue: ['admin'],
    retry_events: ['admin', 'obchod', 'mailing'],
    manage_care: ['admin', 'customer_care'],
    view_care_notes: ['admin', 'customer_care'],
    run_send_tests: ['admin', 'mailing'],
    switch_environment: ['admin'],
    manage_layers: ['admin'],
    send_broadcast: ['admin', 'mailing'],
};
const list = (d) => (typeof d === 'string' ? [d] : d);
const RANK = { none: 0, read: 1, partial: 2, write: 3 };
/** Nejsilnější úroveň přes všechna oddělení uživatele. */
export function accessFor(departments, screen) {
    let best = 'none';
    for (const d of list(departments)) {
        const a = ACCESS[screen][d];
        if (RANK[a] > RANK[best])
            best = a;
    }
    return best;
}
export function canAccess(departments, screen) {
    return accessFor(departments, screen);
}
export function canWrite(departments, screen) {
    return accessFor(departments, screen) === 'write';
}
export function canRead(departments, screen) {
    return accessFor(departments, screen) !== 'none';
}
export function hasCapability(departments, capability) {
    return list(departments).some((d) => CAPABILITY_DEPARTMENTS[capability].includes(d));
}
//# sourceMappingURL=roles.js.map